<template>
	<el-dialog title="查验详情" class="customDialog attestationDialog" :visible="show" :width="boxWidth" :close-on-click-modal="false"
		append-to-body @opened="handleOpened" :before-close="closedBtn">
		<el-scrollbar class="dialog-scrollbar" v-show="verifyResult.length > 1">
			<ul class="left-tab">
				<li ref="isleft" class="is-left" style="height: 40px"></li>
				<li v-for="(item, index) in verifyResult" :key="index" :class="{ active: activeName === index }"
					@click="handleChoose(index)">
					<img :src="item.img" />
					<p :title="item.name">{{ item.name }}</p>
				</li>
			</ul>
		</el-scrollbar>
		<div class="modal_wrapper">
			<div class="cont">
				<div class="state">
					<span v-if="verifyInfo.type == 'Seal'">
						<img src="@comm/images/document-conversion/electronic/wz_icon.png"
							v-if="verifyInfo.result == '0X00000100' || verifyInfo.result == '-1' || verifyInfo.result == '-2' || verifyInfo.result == '-15'" />
						<img src="@comm/images/document-conversion/electronic/success.png"
							v-else-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')" />
						<img src="@comm/images/document-conversion/electronic/sx_icon.png" v-else />
					</span>
					<span v-else-if="verifyInfo.type == 'Sign'">
						<img src="@comm/images/document-conversion/electronic/wz_icon.png"
							v-if="verifyInfo.result == '0X00000100' || verifyInfo.result == '-1' || verifyInfo.result == '-2' || verifyInfo.result == '-15'" />
						<img src="@comm/images/document-conversion/electronic/qm_icon.png"
							v-else-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')" />
						<img src="@comm/images/document-conversion/electronic/qm_icon_no.png" v-else />
					</span>
					<span v-else>
						<img src="@comm/images/document-conversion/electronic/wz_icon.png"
							v-if="verifyInfo.result == '0X00000100' || verifyInfo.result == '-1' || verifyInfo.result == '-2' || verifyInfo.result == '-15'" />
						<img src="@comm/images/document-conversion/electronic/time_stamp_icon.png"
							v-else-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')" />
						<img src="@comm/images/document-conversion/electronic/time_stamp_icon_no.png" v-else />
					</span>
					<div class="info">
						<div class="info_title"
							v-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')">
							{{ verifyInfo.type == 'Sign' ? "该签名有效！" : (verifyInfo.type == 'TimeStamp' ? '该时间戳有效！' :
									'该签章有效！')
							}}
							<el-tooltip :content="verifyInfo.message" placement="bottom-start" v-if="verifyInfo.message"
								effect="light">
								<img src="@comm/images/document-conversion/warning_icon.png" class="warning_icon" />
							</el-tooltip>
						</div>
						<div class="info_title"
							v-else-if="verifyInfo.result == '0X00000100' || verifyInfo.result == '-1' || verifyInfo.result == '-2' || verifyInfo.result == '15'">
							该{{ verifyInfo.type == 'Sign' ? "签名" : (verifyInfo.type == 'TimeStamp' ? '时间戳' :
									'签章')
							}}有效性未知！
						</div>
						<div class="info_title" v-else>
							{{ verifyInfo.type == 'Sign' ? "该签名无效！" : (verifyInfo.type == 'TimeStamp' ? '该时间戳无效！' :
									'该签章无效！')
							}}
						</div>
						<template
							v-if="verifyInfo.result == '0X00000100' || verifyInfo.result == '-1' || verifyInfo.result == '-2' || verifyInfo.result == '15'">
							<div class="subtitle">
								<span v-if="verifyInfo.result == '0X00000100'">{{ verifyInfo.type == 'Sign' ? "签名" :
										(verifyInfo.type == 'TimeStamp' ? '时间戳' : '签章')
								}}有效性未知。{{ verifyInfo.message }}</span>
								<span v-else-if="verifyInfo.result == '-1'">{{ verifyInfo.type == 'Sign' ? "签名" :
										(verifyInfo.type == 'TimeStamp' ? '时间戳' : '签章')
								}}无法验证。未找到{{ verifyInfo.type ==
		'Sign' ? "签名" : (verifyInfo.type == 'TimeStamp' ? '时间戳' : '签章')
}}插件。</span>
								<span v-else-if="verifyInfo.result == '-2'">{{ verifyInfo.type == 'Sign' ? "签名" :
										(verifyInfo.type == 'TimeStamp' ? '时间戳' : '签章')
								}}无法验证。外部模板。</span>
								<span v-else>{{ verifyInfo.type == 'Sign' ? "签名" : (verifyInfo.type == 'TimeStamp' ?
										'时间戳' : '签章')
								}}无法验证。{{ verifyInfo.message }}</span>
							</div>
						</template>
						<template v-else>
							<div class="subtitle" v-if="verifyInfo.type == 'Seal'">
								<span v-if="verifyInfo.result == '-4'">受该签章保护的版权内容<strong>已被修改。</strong></span>
								<span
									v-else-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')">受该签章保护的版权内容<strong>未被修改。</strong></span>
								<span v-else>签章验证有误。{{ verifyInfo.message }}</span>
							</div>
							<div class="subtitle" v-if="verifyInfo.type == 'Sign'">
								<span v-if="verifyInfo.result == '-4'">签名验证有误，无法解析该签章</span>
								<span
									v-else-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')">该签名受保护的部分<strong>未被修改。</strong></span>
								<span v-else>{{ verifyInfo.message }}</span>
							</div>
							<div class="subtitle" v-if="verifyInfo.type == 'TimeStamp'">
								<span v-if="verifyInfo.result == '-4'">受该时间戳保护的版权内容<strong>有变更。</strong></span>
								<span
									v-else-if="verifyInfo.result == 0 || (verifyInfo.result >= '0X00000900' && verifyInfo.result <= '0X000009FF')">受该时间戳保护的版权内容<strong>未被修改。</strong></span>
								<span v-else>{{ verifyInfo.message }}</span>
							</div>
						</template>
					</div>
				</div>
				<div class="signature">
					<div class="signature_title">
						{{ verifyInfo.type == 'Sign' ? '签名信息' : (verifyInfo.type == 'TimeStamp' ? '时间戳信息' : '签章信息') }}
						<div class="button_box">
							<el-button type="text" v-if="verifyInfo.type != 'TimeStamp'" @click="attributeBtn(1)">
								{{ verifyInfo.type == 'Sign' ? '签名属性' : '签章属性' }}</el-button>
							<el-button type="text" @click="certificateBtn(2)">
								{{ verifyInfo.type == 'Sign' ? '签名人证书' : (verifyInfo.type == 'TimeStamp' ? '时间戳证书' :
										'签章人证书')
								}}
							</el-button>
						</div>
					</div>
					<div class="info">
						<div class="list_item">
							<span class="label">{{ verifyInfo.type == 'Sign' ? '签名人：' : (verifyInfo.type == 'TimeStamp'
									? '创建者' : '签章人：')
							}}</span>
							<p>{{ verifyInfo.signature.people }}</p>
						</div>
						<div class="list_item">
							<span class="label">{{ verifyInfo.type == 'Sign' ? '签名时间：' : (verifyInfo.type == 'TimeStamp'
									? '创建时间' : '签章时间：')
							}}</span>
							<p>{{ verifyInfo.signature.date }}</p>
						</div>
					</div>
				</div>
				<div class="seal" v-if="verifyInfo.type == 'Seal'">
					<div class="seal_title">印章信息
						<div class="button_box">
							<el-button type="text" @click="attributeBtn(2)">印章属性</el-button>
							<el-button type="text" @click="certificateBtn(1)">制章人证书</el-button>
						</div>
					</div>
					<div class="info">
						<div class="list_item">
							<span class="label">印章名称：</span>
							<p>{{ verifyInfo.seal.people }}</p>
						</div>
						<div class="list_item">
							<span class="label">有效起止时间：</span>
							<p>{{ verifyInfo.seal.date }}</p>
						</div>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer" style="text-align: right;">
				<el-button @click="closedBtn" size="small">&ensp;关闭&ensp;</el-button>
			</div>
		</div>
		<attributeInfo :show.sync="attributeDialog" :seal-info.sync="sealInfo" />
		<sealPropertiesInfo :overOnLine="overOnLine" :show.sync="sealPropertiesDialog" :seal-info.sync="sealInfo" />
		<certificateInfo :overOnLine="overOnLine" :show.sync="certificateDialog" :seal-info-list.sync="certificateInfo" :timeInfo="timeInfo" />
	</el-dialog>
</template>

<script>
import attributeInfo from "./attributeInfo.vue";
import certificateInfo from "./certificateInfo.vue";
import sealPropertiesInfo from "./sealPropertiesInfo.vue";
export default {
	name: "infoDialog",
	components: {
		attributeInfo,
		certificateInfo,
		sealPropertiesInfo
	},
	props: {
		show: { type: Boolean, default: false },
		sealInfoList: { type: Array, default: () => [] },
		verifyResult: { type: Array, default: () => [] },
		overOnLine: { type: Boolean, default: false },
	},
	data() {
		return {
			key: "value",
			activeName: 0,
			boxWidth: '640px',
			verifyInfo: {
				result: true,
				type: '',
				message: '',
				signature: {
					people: "",
					date: "",
					img: ""
				},
				seal: {
					people: "",
					date: ""
				}
			},
			attributeDialog: false,
			certificateDialog: false,
			sealInfo: {},
			certificateInfo: [],
			sealPropertiesDialog: false,
			timeInfo:""
		};
	},
	watch: {
		show(newValue, oldValue) {
			if (newValue) {
				const firstData = this.sealInfoList[0];
				const firstResult = this.verifyResult[0];
				this.verifyInfo = {
					result: firstResult.code,
					message: firstResult.message,
					type: firstData.type,
					signature: {
						people: firstData.signCert.subjectInfo.commonName,
						date: firstData ? firstData.timeInfo : null
					},
					seal: {
						people: firstData.sealName,
						date: `从 ${firstData.validStart} 到 ${firstData.validEnd}`
					}
				};
				this.sealInfo = this.sealInfoList[0]
				this.sealInfo.commonName = this.sealInfo.signCert.subjectInfo.commonName
			}
		},
		verifyResult(newValue) {
			if (newValue.length > 1) {
				this.boxWidth = "788px"
			} else {
				this.boxWidth = "640px"
			}
		}
	},
	methods: {
		attributeBtn(type) {
			if (type == 1) {
				this.attributeDialog = true
			} else {
				this.sealPropertiesDialog = true
			}
		},
		certificateBtn(type) {
			let certChain = [];
			this.sealInfo.sealCert.startTime = this.sealInfo.sealCert.start
			this.sealInfo.sealCert.endTime = this.sealInfo.sealCert.end
			this.sealInfo.signCert.startTime = this.sealInfo.signCert.start
			this.sealInfo.signCert.endTime = this.sealInfo.signCert.end
			if(type == 1){
				certChain = !this.sealInfo.sealCertChain||!this.sealInfo.sealCertChain.length ? [this.sealInfo.sealCert] : this.sealInfo.sealCertChain.slice().reverse()
			}else{
				certChain = !this.sealInfo.signCertChain||!this.sealInfo.signCertChain.length ? [this.sealInfo.signCert] : this.sealInfo.signCertChain.slice().reverse()
			}

			this.certificateInfo = certChain
			this.timeInfo = this.sealInfo.timeInfo
			this.certificateInfo.forEach((item,index)=>{
					item.id = index + 1
					item.parentId = index == 0 ? null : index
					item.label = item.subjectInfo?item.subjectInfo.commonName:""
				})
			this.certificateDialog = true
		},
		handleOpened() {
			this.activeName = 0;
			this.$refs.isleft.style = "transform: translateY(0px)";
		},
		handleChoose(tabIndex) {
			this.activeName = tabIndex;
			this.verifyInfo = {
				result: this.verifyResult[tabIndex].code,
				message: this.verifyResult[tabIndex].message,
				type: this.sealInfoList[tabIndex].type,
				signature: {
					people: this.sealInfoList[tabIndex].signCert.subjectInfo.commonName,
					date: this.sealInfoList[tabIndex].timeInfo,
					img: this.sealInfoList[tabIndex].sealImage.pictureData
				},
				seal: {
					people: this.sealInfoList[tabIndex].sealName,
					date: `从 ${this.sealInfoList[tabIndex].validStart} 到 ${this.sealInfoList[tabIndex].validEnd}`
				}
			};
			this.sealInfo = this.sealInfoList[tabIndex]
			this.sealInfo.commonName = this.sealInfo.signCert.subjectInfo.commonName
			this.$refs.isleft.style = `transform: translateY(${tabIndex * 40}px);`;
		},
		closedBtn() {
			this.activeName = 0;
			this.$emit("update:show", false);
		}
	}
};
</script>

<style lang="scss" scoped>

.dialog-scrollbar {
	height: 460px;
	width: 148px;
	overflow-x: hidden;
	background: #f5f7fa;
}

.left-tab {
	overflow: hidden;
	width: 100%;
	height: auto;
	position: relative;

	li.is-left {
		position: absolute;
		top: 0;
		left: 0;
		width: 2px;
		height: 40px;
		background-color: #409eff;
		z-index: 1;
		transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
		list-style: none;
		padding: 0;
		margin: 0;
	}

	li {
		height: 40px;
		line-height: 40px;
		padding-left: 20px;
		display: flex;
		align-items: center;
		cursor: pointer;
		color: #8b97af;
		font-size: 12px;

		&:hover {
			p {
				color: #14a8f0;
			}
		}

		img {
			width: 24px;
			margin-right: 6px;
		}

		p {
			flex: 1;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			word-break: break-all;
		}
	}

	li.active {
		background-color: #fff;
		color: #14a8f0;
	}
}

.modal_wrapper {
	height: 460px;
	flex: 1;
	vertical-align: top;
	padding: 0px 30px 20px;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	font-family: "Microsoft YaHei";
	overflow-y: auto;
	font-size: 12px;

	.state {
		margin: 16px 0 41px 0;
		padding-bottom: 26px;
		display: flex;
		justify-content: flex-start;
		border-bottom: 1px solid #F3F4F5;

		img {
			width: 48px;
			height: 48px;

			&.warning_icon {
				width: 16px;
				height: 16px;
			}
		}

		.info {
			margin-left: 24px;

			.info_title {
				font-size: 16px;
				color: #242F44;
			}

			.subtitle {
				margin-top: 5px;
				font-size: 12px;
				color: #8B97AF;
			}
		}
	}

	.signature,
	.seal {

		.signature_title,
		.seal_title {
			color: rgba(79, 93, 121, 0.5);
			margin: 32px 0 22px 0;
		}

		.info {


			&>div {
				display: flex;
				justify-content: flex-start;
				margin-bottom: 16px;

				span {
					&:first-child {
						width: 114px;
						text-indent: 16px;
					}
				}

				p {
					flex: 1;
				}
			}
		}
	}
}

.button_box {
	float: right;

	.el-button {
		padding: 0 !important;
		color: #14a8f0 !important;
		border: none !important;
		font-size: 12px !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/supubwps-document-conversion/pages/attestationPage/components/infoDialog.vue